export const FIREBASE_APP = 'FIREBASE_APP'
